// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-border:hover {\n  box-shadow: 0 0 0 4px rgba(106, 119, 128, 0.1);\n}\n.card-border-selected, .card-border-selected:hover {\n  box-shadow: 0 0 0 4px rgba(106, 119, 128, 0.2);\n}\n.select-card:after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
